import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  AppBar,
  Toolbar,
  Tab,
  Fade,
  CircularProgress,
  TextField,
  CardContent,
  Menu,
  ListItemText,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridRenderCellParams,
  GridSelectionModel,
} from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";
import {
  AppContextProps,
  useAppContext,
} from "../../../libs/app-core/AppContext";
import { Toast } from "../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../libs/data-grid-view/useGridApiRef";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import Title from "../../../libs/rhf-mui/ui/Title";
import { Member } from "../../dao/Member";
import { MemberDAO, useMemberList } from "../../dao/MemberDAO";
import { ProjectDAO, useProject } from "../../dao/ProjectDAO";
import { useUniFuncList } from "../../dao/UniFuncDAO";
import { R } from "../../R";
import UcUniFuncPills from "./UcUniFuncPills";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { useGV } from "../../GV";
import { useEffect, useState } from "react";
import { AuthDAO } from "../../dao/AuthDAO";
import { SHA512 } from "crypto-js";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import AppMenuButton from "../../components/AppMenuButton";
import TabPage from "../../components/TabPage";
import MoreIcon from "@mui/icons-material/MoreVert";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import AppBarTabs from "../../components/AppBarTabs";
import { DGV_LOCAL_TEXT, UIHelper } from "../../components/UIHelper";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UcDgvCustomToolbar from "../../components/UcDgvCustomToolbar";
import UcDgvCustomPagination from "../../components/UcDgvCustomPagination";
import { Project } from "../../dao/Project";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";
import {
  ROUTE_common_export,
  ROUTE_member_todo,
  ROUTE_project_merge,
  ROUTE_spwk_to_his,
} from "../../Routes";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import Label from "../../../libs/rhf-mui/ui/Label";
import { SxProps, Theme } from "@mui/material";
import { FrmSpwkToHisParams } from "../FrmSpwkToHis";
import { MultiChoiceDialog } from "../../../libs/app-core/dialogs/MultiChoiceDialog";
import { useForm } from "react-hook-form";
import RhfDateTimePicker from "../../../libs/rhf-mui/RhfDateTimePicker";
import dayjs from "dayjs";
import { UniFormDAO } from "../../dao/UniFormDAO";
import { UniForm } from "../../dao/UniForm";
import { UniAnswer } from "../../dao/UniAnswer";
import { CommonFormManager } from "./CommonFormManager";
import { InputDialog } from "../../../libs/app-core/dialogs/InputDialog";
import { FrmCommonExportParams } from "../FrmCommonExport";
import SpwkQuestionnaireDialog from "../../../libs/app-core/dialogs/SpwkQuestionnaireDialog";
import MultiChoiceDialogBase from "../../../libs/app-core/dialogs/MultiChoiceDialogBase";
import { API } from "../../dao/API";

type Props = {};
type AccountFieldType = "" | "生日" | "身分證" | "員工編號" | "姓名";

const FrmProjectEditor = (props: Props) => {
  const [searchParams] = useSearchParams(); // UrlQueryParams
  const project_guid = searchParams.get("project") ?? "";
  //---------------------------------------------------------------

  const IsToHisLoading = false;
  const [IsShareProject, set_IsShareProject] = useState<boolean>(false);

  const { _UniFuncList } = useUniFuncList();

  const [MenuPosition, set_MenuPosition] = useState<any>(null);
  const [MenuName, set_MenuName] = useState<any>(null);

  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });

  const handleFilterChange = (model: GridFilterModel) => {
    localStorage.setItem("project_guid", project_guid);
    localStorage.setItem("project_filterModel", JSON.stringify(model));
    setFilterModel(model);
  };

  useEffect(() => {
    let guid = localStorage.getItem("project_guid");

    if (guid !== project_guid) {
      localStorage.removeItem("project_filterModel");
    }

    let model = localStorage.getItem("project_filterModel");
    if (model) {
      setFilterModel(JSON.parse(model));
    }
  }, [project_guid]);

  const OnMenuOpen = (event: React.MouseEvent, menu_strip_name: string) => {
    if (MenuPosition) {
      return;
    }
    event.preventDefault();

    set_MenuName(menu_strip_name); // 標記要開啟的 Menu

    const rect = event.currentTarget.getBoundingClientRect();
    set_MenuPosition({ top: rect.top + rect.height, left: rect.left }); // 左下角
  };

  const columns: GridColDef[] = [
    {
      field: "btn_轉入HIS",
      headerName: "轉入HIS",
      width: 150,
      renderCell: (params) => {
        return (
          <Button
            children={"轉入HIS"}
            size={"small"}
            variant="contained"
            color={"error"}
            onClick={() => {
              MessageDialog.Show(ctx, "", "(點 [取消] 離開)", {
                ...DialogButtons.OKCancel,
                async onDialogResult(e) {
                  if (e.DialogResult === "Yes") {
                    const member = params.row as Member;
                    if (member.spwk_uni_func_guids?.length === 0) {
                      Toast.ShowWarning(ctx, "無特作問卷，無法轉入HIS");
                      return;
                    }
                    let member_guid = (params.row as Member).guid;
                    let args: FrmSpwkToHisParams = {
                      project_guid: project_guid,
                      member_guid_list: [member_guid],
                    };
                    ctx.Navigate(ROUTE_spwk_to_his.url, { state: args });
                  }
                },
              });
            }}
          />
        );
      },
    },
    {
      field: "his",
      headerName: "his匯入",
      width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsHisUploadDone()) {
          return "1";
        } else if (!ans.IsHisUploadDone()) {
          return "0";
        } else {
          throw new_ErrorAlert(`7499461 未知的錯誤`);
        }
      },
      renderCell: (params: GridRenderCellParams<string>) => {
        const value = params.value;
        if (value == null) {
          throw new_ErrorAlert("5213615");
        }
        return render_DoneIcon(value);
      },
    },
    {
      field: "gov",
      headerName: "gov匯入",
      width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsGovUploadDone()) {
          return "1";
        } else if (!ans.IsGovUploadDone()) {
          return "0";
        } else {
          throw new_ErrorAlert(`7387491 未知的錯誤`);
        }
      },
      renderCell: (params: GridRenderCellParams<string>) => {
        const value = params.value;
        if (value == null) {
          throw new_ErrorAlert("4801615");
        }
        return render_DoneIcon(value);
      },
    },
    {
      field: "ui",
      headerName: "ui匯入",
      width: 64,
      valueGetter(params) {
        const ans: UniAnswer = params.row;
        if (ans.IsUiUploadDone()) {
          return "1";
        } else if (!ans.IsUiUploadDone()) {
          return "0";
        } else {
          throw new_ErrorAlert(`7385671 未知的錯誤`);
        }
      },
      renderCell: (params: GridRenderCellParams<string>) => {
        const value = params.value;
        if (value == null) {
          throw new_ErrorAlert("4801615");
        }
        return render_DoneIcon(value);
      },
    },
    {
      field: "spwk_done_at",
      headerName: "完成",
      width: 64,
      valueGetter(params) {
        const member: Member = params.row;
        if (member.IsAllQuestDone()) {
          return "1";
        } else if (member.IsSpwkEdit()) {
          return "2";
        } else {
          return "0";
        }
      },
      renderCell: (params: GridRenderCellParams<string>) => {
        const value = params.value;
        if (value == null) {
          throw new_ErrorAlert("4981315");
        }
        return render_DoneIcon(value);
      },
    },

    { field: "xls_ui_done_status", headerName: "xls匯入Ui", width: 200 },
    { field: "xls_spwk_done_status", headerName: "xls匯入spwk", width: 200 },
    { field: "department", headerName: "部門", width: 200 },
    { field: "employee_id", headerName: "工號", width: 200 },
    { field: "member_code", headerName: "個案編號", width: 200 },
    { field: "member_name", headerName: "個案名稱", width: 150 },
    { field: "sid", headerName: "身分證", width: 150 },
    {
      field: "member_rec_dt",
      headerName: "實際健檢日",
      width: 150,
      valueGetter(params) {
        const member: Member = params.row;
        if (member.IsRecDt2999()) {
          return member.rec_dt;
        } else if (member.IsRecDt2999() === false) {
          return "";
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      },
    },

    {
      field: "spwk_uni_func_guids",
      headerName: "特作問卷",
      width: 480,
      renderCell: (params: GridRenderCellParams<string>) => {
        const member: Member = params.row;
        return (
          <UcUniFuncPills
            ctx={ctx}
            UniFuncListCache={_UniFuncList}
            member={member}
            is_spwk={true} // 特作問卷
          />
        );
      },
    },

    {
      field: "common_uni_func_guids",
      headerName: "其他問卷",
      width: 480,
      renderCell: (params: GridRenderCellParams<string>) => {
        const member: Member = params.row;
        return (
          <UcUniFuncPills
            ctx={ctx}
            UniFuncListCache={_UniFuncList}
            member={member}
            is_spwk={false} // 一般問卷
          />
        );
      },
    },

    {
      field: "rec_dt",
      headerName: "特作問卷完成時間",
      width: 200,
      valueGetter(params) {
        const member: Member = params.row;
        if (member.IsSpwkDone()) {
          return member.spwk_done_at;
        } else if (member.IsSpwkDone() === false) {
          return "";
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      },
    },
    {
      field: "all_quest_done_dt",
      headerName: "所有問卷完成時間",
      width: 200,
      valueGetter(params) {
        const member: Member = params.row;
        if (member.IsAllQuestDone()) {
          return member.all_quest_done_dt;
        } else if (member.IsAllQuestDone() === false) {
          return "";
        } else {
          throw new_ErrorAlert("455676318,未知的錯誤");
        }
      },
    },

    {
      field: "btn_轉入FMT",
      headerName: "轉入FMT",
      width: 150,
      renderCell: (params) => {
        return (
          <Button
            children={"轉入FMT"}
            size={"small"}
            variant="contained"
            color={"error"}
            onClick={() => {
              MessageDialog.Show(
                ctx,
                "",
                "施工中，請勿觸碰! (點 [取消] 離開)",
                {
                  ...DialogButtons.DangerCancel,
                  async onDialogResult(e) {
                    if (e.DialogResult === "Yes") {
                      let member_guid = (params.row as Member).guid;
                      await NavigateTo_FrmMemberTodo_Async(ctx, member_guid);
                    }
                  },
                }
              );
            }}
          />
        );
      },
    },
  ];
  const grid_api = useGridApiRef(columns);
  const ctx = useAppContext();
  const GV = useGV();

  const { _Project } = useProject(project_guid);
  const { _MemberList, set_MemberList, refresh_MemberList } =
    useMemberList(project_guid);
  const [select_guid_list, set_select_guid_list] = useState<GridSelectionModel>(
    []
  );
  const [accountField, setAccountField] = useState<AccountFieldType>("");
  const [passwordField, setPasswordField] = useState<AccountFieldType>("");
  const [cid_value, set_cid_value] = useState<string>("");
  const MAX_WIDTH = "lg";
  const [AppBarTabIndex, set_AppBarTabIndex] = useState("tab受檢者列表");
  const rhf = useForm();

  const load_set_value = (_Project: Project) => {
    setAccountField(_Project.account_rule as AccountFieldType);
    setPasswordField(_Project.password_rule as AccountFieldType);
    let quest_start = _Project.quest_start;
    let quest_start_format = dayjs(quest_start).format("YYYY-MM-DD");
    let quest_end = _Project.quest_end;
    let quest_end_format = dayjs(quest_end).format("YYYY-MM-DD");
    rhf.reset({
      start_date:
        quest_start_format === "2999-01-01" ? null : quest_start_format,
      end_date: quest_end_format === "1800-01-01" ? null : quest_end_format,
      common_date:
        _Project.common_date === "2999-01-01" ? null : _Project.common_date,
    });
    set_cid_value(_Project.cid);
  };

  const btnSetCid_Click = async () => {
    if (cid_value == null || cid_value === "") {
      Toast.ShowWarning(ctx, "cid 輸入框，不得為空");
      console.log("請設定 cid 輸入框，不得為空");
    } else {
      MessageDialog.Show(ctx, "是否修改", "cid 輸入框", {
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (_Project == null) {
              return "";
            }
            await ProjectDAO.Update_SetCid(_Project, cid_value);
            alert("更新完成");
            window.location.reload();
          }
        },
      });
    }
  };

  const cid_textfield_onchange = (e: any) => {
    set_cid_value(e.target.value);
  };

  const common_date_onSubmit = async (data: any) => {
    if (data.common_date == null) {
      Toast.ShowWarning(ctx, "一般問卷基準日，不得為空");
    } else {
      MessageDialog.Show(ctx, "是否修改", "批次修改場次一般問卷基準日", {
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (_Project == null) {
              return "";
            }
            await ProjectDAO.Update_CommonDate(_Project, data.common_date);
            alert("更新完成");
            window.location.reload();
          }
        },
      });
    }
  };

  const onSubmit = async (data: any) => {
    if (data.start_date == null || data.end_date == null) {
      Toast.ShowWarning(ctx, "場次開放時間，不得為空");
      console.log("請設定場次開放時間，不得為空");
    } else {
      MessageDialog.Show(ctx, "是否修改", "批次修改場次開放時間", {
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (_Project == null) {
              return "";
            }
            await ProjectDAO.Update_SetStartDate(_Project, data.start_date);
            await ProjectDAO.Update_SetEndDate(_Project, data.end_date);
            console.log("_Project", _Project);
            alert("更新完成");
            window.location.reload();
          }
        },
      });
    }
  };

  /** 重新取得登入資訊(暫時先這樣處理)
   * React 重新整理後，會遺失 State
   * 此畫面為最主要的後台畫面，暫時在此恢復 GV.user
   * FIXME: 更正確的恢復方式
   */
  useEffect(() => {
    if (_Project == null) {
      return;
    }
    load_set_value(_Project);
    if (_Project.project_code.startsWith("#")) {
      set_IsShareProject(true);
    }
    AuthDAO.Info()
      .then((res) => {
        GV.setUser(res);
      })
      .catch((error) => {
        GV.setUser(null);
      })
      .finally(() => {});
  }, [_Project]);

  //按鈕選擇後，批次設定帳號為受檢者員工ID
  //按鈕選擇後，批次設定密碼為受檢者生日
  const btnSetIdPw_Click = async () => {
    if (
      accountField == null ||
      passwordField == null ||
      accountField === "" ||
      passwordField === ""
    ) {
      Toast.ShowWarning(ctx, "帳號密碼，不得為空");
      console.log("請設定要以甚麼欄位為帳號密碼，不得為空");
    } else {
      MessageDialog.Show(ctx, "是否修改", "批次修改受檢者帳號密碼", {
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (_Project == null) {
              return "";
            }
            _Project.account_rule = accountField;
            _Project.password_rule = passwordField;
            await ProjectDAO.Update_SetAccountRule(_Project, accountField);
            await ProjectDAO.Update_SetPassWord(_Project, passwordField);
            await updateData();
          }
        },
      });
    }
  };

  async function updateData(): Promise<void> {
    let count = 0;
    const MaxBatch = 100;
    const totalCount = _MemberList?.length || 0;
    const batchCountThreshold = 100;
    const updatedMembers: Member[] = [];

    do {
      for (let i = count; i < count + MaxBatch && i < totalCount; i++) {
        const member = _MemberList[i];
        if (member) {
          let now_member = await MemberDAO.WS_FetchByGuid(member.guid);
          let id = getValueByIdPwrule(accountField, now_member).toUpperCase();
          let pw = hashValue(
            getValueByIdPwrule(passwordField, now_member).toUpperCase()
          );
          now_member = await MemberDAO.Update_ID_PW(now_member, id, pw);
          updatedMembers.push(now_member);

          if (
            updatedMembers.length % batchCountThreshold === 0 ||
            i === totalCount - 1
          ) {
            Toast.Show(ctx, `已更新 ${updatedMembers.length} 位受檢者`);
          }
        }
      }
      count += MaxBatch;

      await new Promise((resolve) => setTimeout(resolve, 2000)); // 每輪迴結束後等待 2 秒再處理下一批次
    } while (count < totalCount);

    if (updatedMembers.length > 0) {
      set_MemberList([..._MemberList, ...updatedMembers]);
      alert("更新完成");
      window.location.reload();
    }
  }

  return (
    <Box style={linear_content_style}>
      {/* 外框架 */}
      <Grid {...linear_h}>
        <Grid {...linear_item} width={0} bgcolor="">
          {/* 左側主檔 Master */}
          <Box bgcolor=""></Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor="">
          {/* 中間列表 Details */}
          {render_Detail()}
        </Grid>
      </Grid>
    </Box>
  );

  function render_MemberList() {
    return (
      <Box style={linear_content_style} bgcolor={R.color.paper}>
        <Container sx={{ height: "100%", pb: 1, pt: 1 }} maxWidth={false}>
          <Grid {...linear_v}>
            <Grid {...linear_item}></Grid>
            <Grid {...linear_item} flex={1} p={1}>
              {render_DataGrid()}
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            <AppMenuButton label={render_AppTitle()} />
            <Box sx={{ flexGrow: 1 }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {render_ActionButtons()}
          </Toolbar>
          {render_AppTabs()}
        </AppBar>
      </>
    );
  }

  function render_ActionButtons() {
    let sx_icon_button: SxProps<Theme> | undefined = {
      mr: 0,
      py: 1,
      /* gpt: 方形的 Hover */
      borderRadius: "4px",
      "&:hover": {
        boxShadow: "none",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      },
    };
    return (
      <div>
        {!IsShareProject
          ? render_normalProject_actionButtons(sx_icon_button)
          : render_shareProject_actionButtons(sx_icon_button)}
      </div>
    );
  }

  function render_normalProject_actionButtons(
    sx_icon_button: SxProps<Theme> | undefined
  ) {
    return (
      <div>
        {/* 設定特作問卷BTN */}
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
          onClick={(e) => {
            SetSpwkQuestionnaire();
          }}
        >
          <Label variant="button" sx={{ mx: 1 }}>
            設定特作問卷
          </Label>
        </IconButton>
        {/* 設定一般問卷BTN */}
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
          onClick={(e) => {
            設定一般問卷_Click(false); // false: 建立一般問卷後，不覆蓋基本資料
          }}
        >
          <Label variant="button" sx={{ mx: 1 }}>
            設定一般問卷
          </Label>
        </IconButton>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
          onClick={(e) => {
            刪除所選受檢者_Click();
          }}
        >
          <Label variant="button" sx={{ mx: 1 }}>
            刪除所選受檢者
          </Label>
        </IconButton>
        {/* 匯入院內系統BTN */}
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          disabled={IsToHisLoading}
          sx={{ ...sx_icon_button }}
          onClick={btn_匯入院內系統_Click}
        >
          {IsToHisLoading ? (
            <Fade
              in={IsToHisLoading}
              style={{ transitionDelay: IsToHisLoading ? "800ms" : "0ms" }}
              unmountOnExit
            >
              <CircularProgress color="inherit" size="1rem" />
            </Fade>
          ) : (
            <CloudSyncIcon />
          )}
          &nbsp;
          <Label variant="button" sx={{ mr: 1 }}>
            匯入院內系統
          </Label>
        </IconButton>

        <IconButton
          size="large"
          edge="start"
          color="inherit"
          disabled={IsToHisLoading}
          sx={{ ...sx_icon_button }}
          onClick={CaseDtUpdate}
        >
          <Label variant="button" sx={{ mr: 1 }}>
            {dayjs(_Project?.end_dt).year() === 2999 ? "確定結案" : "取消結案"}
          </Label>
        </IconButton>
        <IconButton
          onClick={(e) => OnMenuOpen(e, "Menu更多")}
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
        >
          {render_Menu更多("Menu更多")}
          <MoreIcon />
        </IconButton>
      </div>
    );
  }

  function render_shareProject_actionButtons(
    sx_icon_button: SxProps<Theme> | undefined
  ) {
    return (
      <div>
        {/* 設定一般問卷BTN */}
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
          onClick={(e) => {
            添加共用場次_Click();
          }}
        >
          <Label variant="button" sx={{ mx: 1 }}>
            添加共用場次
          </Label>
        </IconButton>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          disabled={IsToHisLoading}
          sx={{ ...sx_icon_button }}
          onClick={CaseDtUpdate}
        >
          <Label variant="button" sx={{ mr: 1 }}>
            {dayjs(_Project?.end_dt).year() === 2999 ? "確定結案" : "取消結案"}
          </Label>
        </IconButton>
        <IconButton
          onClick={(e) => OnMenuOpen(e, "Menu更多")}
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
        >
          {render_Menu更多("Menu更多")}
          <MoreIcon />
        </IconButton>
      </div>
    );
  }

  /**
   * 設定特作問卷
   */
  function SetSpwkQuestionnaire() {
    //#region 選擇的受檢者列表 sel_member_list
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();
    let sel_member_list: Member[] = [];
    sel_rows?.forEach(function (value, key) {
      let member = value as Member;
      sel_member_list.push(member);
    });

    if (sel_member_list.length === 0) {
      MessageDialog.Show(ctx, "請先勾選受檢者");
      return;
    }
    //#endregion
    ctx?.ShowDialog(SpwkQuestionnaireDialog, {
      onDialogClosed: async (spwkList) => {
        if (!spwkList || spwkList.length === 0) {
          Toast.ShowDanger(ctx, "未輸入任何特作代碼");
          return;
        }

        if (!sel_member_list || sel_member_list.length === 0) {
          Toast.ShowDanger(ctx, "未選取任何受檢者");
          return;
        }

        const projectGuid = sel_member_list[0].project_guid;
        // 取得場次基本資料
        const project = await ProjectDAO.FetchByGuid(projectGuid);

        // 整理受檢者名單、選取的特作名單、撈取場次基本資料上傳
        // request body
        const data = {
          code: project.project_code,
          name: project.project_name,
          business_code: project.business_code,
          date: project.rec_dt,
          cust_code: project.cust_code,
          cust_name: project.cust_name,
          members: sel_member_list.map((m) => {
            return {
              code: m.member_code,
              name: m.member_name,
              sid: m.sid,
              gender: m.gender,
              birth_date: m.birth_date,
              job_start_date: m.start_date,
              job_title: m.job_title,
              employee_id: m.employee_id,
              appointment_date: m.appointment_date,
              company_tax_id: m.company_tax_id,
              department: m.department,
              special_works: spwkList,
              common_works: [],
            };
          }),
        };

        console.log(`準備更新特作問卷`);
        console.log(data);
        try {
          const result = await API.Call_POST(`/api/sys/project`, data);
          console.log(result);
          console.log(`已成功更新特作問卷`);
          Toast.ShowScuccess(ctx, `已成功更新特作問卷`);

          // 刷新名單資料
          await refresh_MemberList();
        } catch (error) {
          console.log(error);
          console.log(`更新特作問卷時發生錯誤`);
          Toast.ShowDanger(ctx, `更新特作問卷時發生錯誤`);
        }
      },
    });
  }

  /**
   *  取得 Dgv 上選擇的 Member (sel_member_list)
   *  跳出多選視窗 選擇要開單的一般問卷 (common_form_list)
   *
   */
  async function 設定一般問卷_Click(is_覆蓋基本資料: boolean) {
    //#region 選擇的受檢者列表 sel_member_list
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();
    let sel_member_list: Member[] = [];
    sel_rows?.forEach(function (value, key) {
      let member = value as Member;
      sel_member_list.push(member);
    });

    if (sel_member_list.length === 0) {
      MessageDialog.Show(ctx, "請先勾選受檢者");
      return;
    }
    //#endregion

    //#region Valid
    if (_Project?.common_date === "2999-01-01") {
      MessageDialog.Show(ctx, "請先設定一般問卷基準日");
      return;
    }
    //#endregion

    // 取得所有當前一般問卷列表(個問卷 "最新" curr 版本)
    const curr_common_form_list = await Select_最新的一般問卷UniForms();

    //#region dialog message = 共選擇 N 位受檢者
    let message = "";
    if (sel_member_list.length < 5) {
      message = sel_member_list.map((member) => member.member_name).join(", ");
    } else {
      message = "共選擇: " + sel_member_list.length + " 位受檢者";
    }

    message += "\n";
    message +=
      "缺少生日的: " +
      sel_member_list.filter((x) => IsBlankDay(x.birth_date)).length +
      "\n";
    message +=
      "缺少到職日的: " +
      sel_member_list.filter((x) => IsBlankDay(x.start_date)).length +
      "\n";
    message +=
      "缺少基準日的: " +
      sel_member_list.filter((x) => IsBlankDay(x.common_date)).length +
      "\n";

    //#endregion

    let items: string[] = curr_common_form_list.map(
      (x) => `[${x.form_code}] ${x.form_title}`
    );
    return MultiChoiceDialog.Show(
      ctx,
      `受檢者:${message}`,
      "設定一般問卷",
      items,
      null,
      {
        yesText: "加入一般問卷",
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            let checks: boolean[] = e.Data;
            console.log("checks: ", checks);

            //#region selected_curr_common_forms = 取得選擇的 一般問卷 (UniForms)
            let sel_curr_common_forms: UniForm[] = []; //選擇的一般問卷的UniForm[]

            e.Data.forEach(function (data_boolean: boolean, index: number) {
              curr_common_form_list.forEach(function (
                common_form: UniForm,
                common_form_index: number
              ) {
                if (index === common_form_index && data_boolean === true) {
                  sel_curr_common_forms.push(common_form);
                }
              });
            });
            //#endregion

            await 指定_受檢者_開_指定一般問卷(
              ctx,
              sel_member_list,
              sel_curr_common_forms,
              is_覆蓋基本資料
            );
          } else {
            Toast.ShowDanger(ctx, "未輸入!");
          }
        },
      }
    );
  }
  async function 刪除所選受檢者_Click() {
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();
    let sel_member_list: Member[] = [];
    sel_rows?.forEach(function (value, key) {
      let member = value as Member;
      sel_member_list.push(member);
    });
    if (sel_member_list.length === 0) {
      MessageDialog.Show(ctx, "請先勾選受檢者");
      return;
    }
    let message = "";
    if (sel_member_list.length < 5) {
      message = sel_member_list.map((member) => member.member_name).join(", ");
    } else {
      message = `共選擇${sel_member_list.length}位受檢者`;
    }
    message += "\n";
    message +=
      "完成特作問卷的: " +
      sel_member_list.filter((x) => !IsBlankDay(x.spwk_done_at)).length +
      "\n";
    message +=
      "完成所有問卷的: " +
      sel_member_list.filter((x) => !IsBlankDay(x.all_quest_done_dt)).length +
      "\n";

    return MessageDialog.Show(ctx, `受檢者:${message}`, "是否刪除", {
      ...DialogButtons.DangerCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          for (const member of sel_member_list) {
            await MemberDAO.Delete(member);
            let ans = await UniAnswerDAO.WS_Select_ByMemberGuid(member.guid);
            for (const del_ans of ans) {
              await UniAnswerDAO.Delete(del_ans);
            }
            let new_member = await MemberDAO.Select(project_guid);
            set_MemberList(new_member);
          }
          Toast.Show(ctx, "刪除完成");
        }
      },
    });
  }

  function IsBlankDay(day_str: string) {
    let tf =
      day_str === null ||
      day_str === "" ||
      day_str.includes("1800") ||
      day_str.includes("2999") ||
      day_str.includes("0000");
    return tf;
  }

  async function 指定_受檢者_開_指定一般問卷(
    ctx: AppContextProps,
    sel_member_list: Member[],
    sel_curr_common_forms: UniForm[],
    is_覆蓋基本資料: boolean
  ) {
    console.log(
      "對這些 Members 開這些 Forms:",
      "sel_member_list:",
      sel_member_list,
      "selected_common_forms:",
      sel_curr_common_forms
    );

    if (sel_member_list.length === 0) {
      MessageDialog.Show(ctx, "必須選擇 受檢者 !");
      return;
    }

    if (sel_curr_common_forms.length === 0) {
      MessageDialog.Show(ctx, "必須選擇 問卷 !");
      return;
    }

    //#region Valid
    let not_curr_forms = sel_curr_common_forms.filter((x) => x.is_curr === 0);
    if (not_curr_forms.length !== 0) {
      throw new_ErrorAlert("456864 必須都是 curr=1");
    }
    //#endregion
    CommonFormManager.批次新增一般問卷_KYLe(
      sel_member_list,
      sel_curr_common_forms,
      ctx,
      is_覆蓋基本資料
    );
  }
  /**
   *  取得 Dgv 上選擇的 Member (sel_member_list)
   *  跳出多選視窗 選擇要開單的一般問卷 (common_form_list)
   *
   */
  async function Select_最新的一般問卷UniForms() {
    try {
      const result = await UniFormDAO.Select_最新的一般問卷();
      return result;
    } catch {
      throw new_ErrorAlert("94215");
    }
  }

  //-------------------------------------------------------------------------------------------

  function CaseDtUpdate() {
    if (dayjs(_Project?.end_dt).year() === 2999) {
      CloseCase();
    } else if (dayjs(_Project?.end_dt).year() !== 2999) {
      CancelCloseCase();
    } else {
      throw new_ErrorAlert(`3197652 請確認end_dt`);
    }
  }
  async function CloseCase() {
    if (_Project == null) {
      throw new_ErrorAlert(`1976453 _Project不該為null`);
    }
    //不確定要用dayjs()還是Date
    const nowTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
    MessageDialog.Show(ctx, "", "是否將此場次結案! (點 [取消] 離開)", {
      ...DialogButtons.OKCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          await ProjectDAO.UpdateEndDtOnly(_Project, nowTime);
        }
      },
    });
  }
  function CancelCloseCase() {
    if (_Project == null) {
      throw new_ErrorAlert(`1946753 _Project不該為null`);
    }
    const Time = "2999-01-01 00:00:00";

    MessageDialog.Show(ctx, "", "是否將此場次取消結案! (點 [取消] 離開)", {
      ...DialogButtons.DangerCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          await ProjectDAO.UpdateEndDtOnly(_Project, Time);
        }
      },
    });
  }
  async function btn_匯入院內系統_Click() {
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();

    let member_list: Member[] = [];

    sel_rows?.forEach(function (value, key) {
      let member = value as Member;
      // 略過無特作問卷的受檢者
      if (member.spwk_uni_func_guids?.length === 0) {
        return;
      }
      member_list.push(member);
    });

    if (member_list.length === 0) {
      MessageDialog.Show(ctx, "請先勾選受檢者");
      return;
    }

    let args: FrmSpwkToHisParams = {
      project_guid: project_guid,
      member_guid_list: member_list.map((x) => x.guid),
    };
    ctx.Navigate(ROUTE_spwk_to_his.url, { state: args });
  }

  function render_AppTabs() {
    return (
      <Container>
        <AppBarTabs
          AppBarTabIndex={AppBarTabIndex}
          set_AppBarTabIndex={set_AppBarTabIndex}
        >
          <Tab label="受檢者列表" value={"tab受檢者列表"} />
          <Tab label="場次資訊" value={"tab場次資訊"} />
        </AppBarTabs>
      </Container>
    );
  }

  function render_Detail() {
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            <Box style={linear_content_style} sx={{ bgcolor: R.color.paper }}>
              <TabPage
                tab_key={"tab受檢者列表"}
                curr_tab={AppBarTabIndex}
                sx={{ height: "100%", overflow: "hidden" }}
              >
                <Box sx={{ height: "100%" }}>{render_MemberList()}</Box>
              </TabPage>

              {/* Tab範例: Master列表型 - 填滿畫面 (yellow)*/}
              <TabPage
                tab_key={"tab場次資訊"}
                curr_tab={AppBarTabIndex}
                sx={{ bgcolor: R.color.paper }}
              >
                <Container maxWidth={MAX_WIDTH} sx={{}}>
                  <Grid
                    container
                    columnSpacing={2}
                    rowSpacing={2}
                    sx={{ mt: 2 }}
                  >
                    <Grid item xs={12}>
                      <Label color={"error"}>
                        此頁設定完後請重新整理 或 重新進入場次 刷新受檢者資料
                      </Label>
                    </Grid>
                    <Grid item xs={3}>
                      {render_IdPwInfo()}
                    </Grid>
                    {/* {render_InsertFunc()} */}
                    <Grid item xs={3}>
                      {render_Set_Session_Date_Area()}
                    </Grid>
                    <Grid item xs={3}>
                      {render_Set_Cid_Area()}
                    </Grid>
                    <Grid item xs={3}>
                      {render_Set_Common_Date_Area()}
                    </Grid>
                  </Grid>
                </Container>
              </TabPage>
              {/* Tab範例: Master列表型 - 填滿畫面 (yellow)*/}
              <TabPage
                tab_key={"Tab2"}
                curr_tab={AppBarTabIndex}
                sx={{ bgcolor: "#FFFFCC", height: "100%", overflow: "hidden" }}
              >
                <Container
                  maxWidth={MAX_WIDTH}
                  sx={{ height: "100%", bgcolor: "#DDDDCC" }}
                >
                  {UIHelper.render_Content("Item Two", 10)}
                </Container>
              </TabPage>

              {/* Tab範例: Detail表單型 - 含卷軸 (blue) */}
              <TabPage
                tab_key={"Tab3"}
                curr_tab={AppBarTabIndex}
                sx={{ bgcolor: "#CCCCFF" }}
              >
                <Container maxWidth={MAX_WIDTH} sx={{ bgcolor: "#AAAAEE" }}>
                  {UIHelper.render_Content("Item Three", 30)}
                </Container>
              </TabPage>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  function render_IdPwInfo() {
    return (
      <Card>
        <CardContent>
          <Grid container direction={"column"} sx={{ py: 2 }}>
            <Grid item sx={{ mb: 2 }}>
              <Title>帳密規則</Title>
            </Grid>
            <Grid
              item
              container
              spacing={1}
              justifyItems={"center"}
              direction={"column"}
              sx={{ width: "100%" }}
            >
              <Grid item>
                <InputLabel shrink={true}>以何者取代帳號</InputLabel>
                <Select
                  size="small"
                  value={accountField}
                  label="以何者取代帳號"
                  sx={{ minWidth: "160px" }}
                  onChange={(e) =>
                    setAccountField(e.target.value as AccountFieldType)
                  }
                >
                  <MenuItem value={"生日"}>生日</MenuItem>
                  <MenuItem value={"身分證"}>身分證</MenuItem>
                  <MenuItem value={"員工編號"}>員工編號</MenuItem>
                  <MenuItem value={"姓名"}>姓名</MenuItem>
                </Select>
              </Grid>
              <Grid item>
                <InputLabel shrink={true}>以何者取代密碼</InputLabel>
                <Select
                  size="small"
                  value={passwordField}
                  label="以何者取代密碼"
                  sx={{ minWidth: "160px" }}
                  onChange={(e) =>
                    setPasswordField(e.target.value as AccountFieldType)
                  }
                >
                  <MenuItem value={"生日"}>生日</MenuItem>
                  <MenuItem value={"身分證"}>身分證</MenuItem>
                  <MenuItem value={"員工編號"}>員工編號</MenuItem>
                  <MenuItem value={"姓名"}>姓名</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Grid item sx={{ mt: 2 }}>
              <Button
                color="inherit"
                variant="contained"
                onClick={btnSetIdPw_Click}
              >
                更改受檢者帳號密碼
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  function render_Set_Common_Date_Area() {
    return (
      <Card>
        <CardContent>
          <form onSubmit={rhf.handleSubmit(common_date_onSubmit)}>
            <Grid container direction={"column"} sx={{ py: 2 }}>
              <Grid item sx={{ mb: 2 }}>
                <Title>一般問卷基準日</Title>
              </Grid>
              <Grid
                item
                container
                spacing={1}
                justifyItems={"center"}
                direction={"row"}
                sx={{ width: "100%" }}
              >
                <Grid item>
                  <InputLabel shrink={true}>基準日</InputLabel>
                  <RhfDateTimePicker
                    rhf={rhf}
                    name={"common_date"}
                    size={"small"}
                    sx={{ width: "80%" }}
                  />
                </Grid>
              </Grid>
              <Grid item sx={{ mt: 2 }}>
                <Button color="inherit" variant="contained" type="submit">
                  更改一般問卷基準日
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    );
  }

  function render_Set_Session_Date_Area() {
    return (
      <Card>
        <CardContent>
          <form onSubmit={rhf.handleSubmit(onSubmit)}>
            <Grid container direction={"column"} sx={{ py: 2 }}>
              <Grid item sx={{ mb: 2 }}>
                <Title>場次開放時間</Title>
              </Grid>
              <Grid
                item
                container
                spacing={1}
                justifyItems={"center"}
                direction={"row"}
                sx={{ width: "100%" }}
              >
                <Grid item>
                  <InputLabel shrink={true}>場次開始日</InputLabel>
                  <RhfDateTimePicker
                    rhf={rhf}
                    name={"start_date"}
                    size={"small"}
                    sx={{ width: "80%" }}
                  />
                </Grid>
                <Grid item>
                  <InputLabel shrink={true}>場次結束日</InputLabel>
                  <RhfDateTimePicker
                    rhf={rhf}
                    name={"end_date"}
                    size={"small"}
                    sx={{ width: "80%" }}
                  />
                </Grid>
              </Grid>
              <Grid item sx={{ mt: 2 }}>
                <Button color="inherit" variant="contained" type="submit">
                  更改場次開放時間
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    );
  }

  function render_Set_Cid_Area() {
    return (
      <Card>
        <CardContent>
          <Grid container direction={"column"} sx={{ py: 2 }}>
            <Grid item>
              <Title sx={{ mb: 2 }}>場次Cid</Title>
            </Grid>
            <Grid
              item
              container
              spacing={1}
              justifyItems={"center"}
              direction={"row"}
              sx={{ width: "100%" }}
            >
              <Grid item>
                <TextField
                  label="輸入場次cid"
                  value={cid_value}
                  onChange={(e) => {
                    cid_textfield_onchange(e);
                  }}
                  size={"small"}
                  sx={{ width: "80%" }}
                />
              </Grid>
            </Grid>
            <Grid item sx={{ mt: 2 }}>
              <Button
                color="inherit"
                variant="contained"
                onClick={(e) => {
                  btnSetCid_Click();
                }}
              >
                更改場次cid
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  function render_AppTitle() {
    if (_Project == null) {
      return "";
    } else {
      return (
        <Title variant="subtitle2">
          {" "}
          {"[" + _Project?.project_code + "] " + _Project?.project_name}
        </Title>
      );
    }
  }

  function render_DataGrid() {
    return (
      <Card sx={{ height: "100%", width: "100%" }}>
        <DataGrid
          sx={{
            width: "100%",
            backgroundColor: "white",
            padding: "12px",
            border: "none",
          }}
          filterModel={filterModel}
          onFilterModelChange={handleFilterChange}
          components={{
            Toolbar: () => {
              return (
                <UcDgvCustomToolbar>
                  <IconButton
                    onClick={() => {
                      Toast.Show(ctx, "More");
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </UcDgvCustomToolbar>
              );
            },
            Pagination: () => {
              return <UcDgvCustomPagination />;
            },
          }}
          localeText={DGV_LOCAL_TEXT} // 中文
          checkboxSelection={true}
          disableSelectionOnClick={true}
          getRowId={(data) => {
            return data.guid;
          }}
          rows={_MemberList}
          columns={grid_api.columns}
          pageSize={100}
          rowsPerPageOptions={[100]}
          onSelectionModelChange={(newSelectionModel) => {
            //選項改變時觸發
            set_select_guid_list(newSelectionModel); // newSelectionModel 是被選取 gird 的 guid[]
          }}
          selectionModel={select_guid_list} // selectionModel prop 控制選項
          onRowDoubleClick={(params) => {
            Toast.Show(ctx, "個案: " + params.id);
          }}
        />
      </Card>
    );
  }
  function render_Menu更多(menu_name: string) {
    return (
      <Menu
        open={!!MenuPosition && MenuName === menu_name}
        onClose={() => set_MenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={MenuPosition}
      >
        <MenuItem
          onClick={() => {
            CancelAllImport();
            CloseMenu();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>取消所有匯入</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            InputDialog.Show(ctx, "", "請輸入驗證碼", "", {
              async onDialogResult(e) {
                if (e.DialogResult === "Yes") {
                  if (e.Data === "5229") {
                    設定一般問卷_Click(true); // true=覆蓋基本資料
                    Toast.Show(ctx, "已執行完成");
                  } else {
                    Toast.Show(ctx, "驗證失敗!");
                  }
                }
              },
            });
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>設定一般問卷(並覆蓋基本資料)</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            匯出一般問卷_Click();
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>匯出 一般問卷</ListItemText>
        </MenuItem>
      </Menu>
    );
  }

  function 匯出一般問卷_Click() {
    const sel_rows = grid_api.apiRef.current?.getSelectedRows();

    let member_list: Member[] = [];

    sel_rows?.forEach(function (value, key) {
      let member = value as Member;
      member_list.push(member);
    });

    if (member_list.length === 0) {
      MessageDialog.Show(ctx, "請先勾選受檢者");
      return;
    }

    let args: FrmCommonExportParams = {
      project_guid: project_guid,
      member_guid_list: member_list.map((x) => x.guid),
    };

    ctx.Navigate(ROUTE_common_export.url, { state: args });
  }
  async function 添加共用場次_Click() {
    return MessageDialog.Show(ctx, "", "確認添加共用場次?", {
      ...DialogButtons.OKCancel,
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          ctx.Navigate(ROUTE_project_merge.url + "?project=" + project_guid);
        } else {
          Toast.Show(ctx, "取消匯入");
        }
      },
    });
  }

  function CancelAllImport() {
    InputDialog.Show(ctx, "", "請輸入驗證碼", "", {
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          if (e.Data === "5229") {
            for (const member of _MemberList) {
              console.log(member.member_code);
              await MemberDAO.UpdateOneField(
                member,
                "his_upload_dt",
                "2999-01-01 00:00:00"
              );
              await MemberDAO.UpdateOneField(
                member,
                "gov_upload_dt",
                "2999-01-01 00:00:00"
              );
              await MemberDAO.UpdateOneField(
                member,
                "his_upload_err_msg",
                null
              );
              await MemberDAO.UpdateOneField(
                member,
                "gov_upload_err_msg",
                null
              );
              await new Promise((resolve) => setTimeout(resolve, 200));
            }
            Toast.Show(ctx, "已執行完成");
          } else {
            Toast.Show(ctx, "驗證失敗!");
          }
        }
      },
    });
  }
  function CloseMenu() {
    set_MenuPosition(null);
  }

  function hashValue(value: string | CryptoJS.lib.WordArray) {
    const hash = SHA512(value);
    return hash.toString();
  }
};

export async function NavigateTo_FrmMemberTodo_Async(
  ctx: AppContextProps,
  member_guid: string
) {
  let member_data = await MemberDAO.WS_FetchByGuid(member_guid);
  if (member_data == null) {
    throw new_ErrorAlert("56791345 沒有member_data");
  } else {
    ctx.Navigate(ROUTE_member_todo.url + "?member_guid=" + member_guid);
  }
}

export default FrmProjectEditor;

function getValueByIdPwrule(data: string, member: Member): string {
  switch (data) {
    case "生日":
      //xxxx-xx-xx
      const birthYear = parseInt(member.birth_date.split("-")[0]);
      const birthMonth = parseInt(member.birth_date.split("-")[1])
        .toString()
        .padStart(2, "0");
      const birthDay = parseInt(member.birth_date.split("-")[2])
        .toString()
        .padStart(2, "0");
      const taiwanYear = birthYear - 1911; // 西元年轉換為民國年
      const taiwanDate = `${taiwanYear}${birthMonth}${birthDay}`; // 組合成字串
      return taiwanDate;
    case "身分證":
      return member.sid;
    case "員工編號":
      return member.employee_id;
    case "姓名":
      return member.member_name;
    default:
      throw new Error("錯誤的選項");
  }
}

function render_DoneIcon(status: string) {
  if (status === "1") {
    return (
      <IconButton
        size="small"
        edge="start"
        color="success"
        aria-label="menu"
        sx={{ mr: 2 }}
      >
        <CheckCircleIcon />
      </IconButton>
    );
  } else if (status === "0") {
    return (
      <IconButton
        size="small"
        edge="start"
        aria-label="menu"
        sx={{ mr: 2, color: "#DDDDDD" }}
      >
        <IndeterminateCheckBoxIcon />
      </IconButton>
    );
  } else if (status === "2") {
    return (
      <IconButton
        size="small"
        edge="start"
        aria-label="menu"
        sx={{ mr: 2, color: "#0000FF" }}
      >
        <DoubleArrowIcon />
      </IconButton>
    );
  } else {
    throw new_ErrorAlert("9713642");
  }
}
